// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import ROIView from "./view";

import PendingComponent from "../../components/PendingComponent";
import { isMeaningfulGigsOrDemo } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const roiRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "roi",
  validateSearch(search: Record<string, unknown>) {
    const schema = z.object({
      startDate: z.string().optional(),
      endDate: z.string().optional(),
    });

    return schema.parse(search);
  },
  beforeLoad() {
    // Allow MG staff and demo enterprise users — matches the AppSidebar
    // visibility gate so the link doesn't bounce demo users to /tickets.
    if (!isMeaningfulGigsOrDemo()) {
      throw redirect({
        to: ticketsRoute.to,
      });
    }
  },
  loaderDeps({ search }) {
    return {
      startDate: search.startDate,
      endDate: search.endDate,
    };
  },
  async loader({ deps }) {
    return deps;
  },
  component: ROIView,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
